import { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setLogout } from "../features/authSlice";
import LoadingOverlay from "../ui/LoadingOverlay";
import MoonLoader from "react-spinners/MoonLoader";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
// import { useMap } from "https://cdn.esm.sh/react-leaflet/hooks";
import Header from "../components/Header";

import red_popup from "../red_popup.png"; // path to your custom icon
import yellow_popup from "../yellow_popup.png"; // path to your custom icon
// import black_popup from "../black_popup.png"; // path to your custom icon
import style from "./MapResults.module.css";
import { toast } from "react-toastify";
// Fix default icon path issue (optional but useful in some setups)

// Custom component to update the map center
function UpdateMapCenter({ center }) {
  const map = useMap();

  useEffect(() => {
    map.setView(center); // Update the map's center
  }, [center, map]);
  return null;
}

// function base64ToBlob(base64, mime = "image/jpeg") {
//   // Clean base64 (remove newlines and add padding if needed)
//   base64 = base64.replace(/[^A-Za-z0-9+/]/g, ''); // remove invalid characters
//   while (base64.length % 4 !== 0) {
//     base64 += '=';
//   }

//   try {
//     const byteCharacters = atob(base64);
//     const byteArrays = [];

//     for (let i = 0; i < byteCharacters.length; i += 512) {
//       const slice = byteCharacters.slice(i, i + 512);
//       const byteNumbers = new Array(slice.length);
//       for (let j = 0; j < slice.length; j++) {
//         byteNumbers[j] = slice.charCodeAt(j);
//       }
//       byteArrays.push(new Uint8Array(byteNumbers));
//     }

//     return new Blob(byteArrays, { type: mime });
//   } catch (err) {
//     console.error("Failed to decode base64:", err);
//     throw err;
//   }
// }

// const LLM_PORT = 5000; // LLM server port 11434 || 5000
// //  '../../public/images/popup-icon.png'
function MapResults() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [IncidenceDescription,setIncidenceDescription] = useState("");
  const [sendIncident,setSendIncident] = useState(false);
  const mapPosition = useSelector((state) => state.model.mapPosition);
  const { token,user } = useSelector((state) => state.auth);
  const role = user.role
  // const [llmMessage, setLlmMessage] = useState("");
  // const { cityName } = useSelector((state) => state.model);
  const navigate = useNavigate();
  const dispatch = useDispatch();

 
  async function removeIncidence(id){
    setSendIncident(true)
    // console.log(id,IncidenceDescription)
    const endpoint = `https://api.up2smart.com:5001/v1/remove-incident/${id}`
    // const endpoint = `https://192.168.0.102:5001/v1/remove-incident/${id}`

    try{
      const response = await fetch(endpoint, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Add the Authorization header
        },
        body: JSON.stringify({description:IncidenceDescription}),
      });
      if (!response.ok) {
        if (response.status === 401) {
          toast.error("Unauthorized access. Please login again.");
          dispatch(setLogout());
          navigate("/login");
        }
        toast.error("Failed to remove incidence");
        setSendIncident(false)
        return;
      }
      toast.success("Incidence removed successfully");
      // Optionally, you can refresh the data or update the state here
      setData((prevData) => prevData.filter((item) => item.results_id !== id));
    }catch(error){
      console.error("Error removing incidence:", error);
      toast.error("Error removing incidence");
    }finally{
      setSendIncident(false)
    }
  }
  // console.log(user.role);
  useEffect(() => {

    async function fetchData(endpoint = "/v1/final-results") {
      setIsLoading(true);
      const controller = new AbortController(); // Create an AbortController instance
      const timeoutId = setTimeout(() => controller.abort(), 550000); // Set timeout to 5 seconds
      const url = "https://api.up2smart.com:5001" + endpoint;
      // const url = `https://192.168.0.102:5001`+`${endpoint}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`, // Add the Authorization header
          },
          // body: JSON.stringify({ city: user.city }),
          signal: controller.signal, // Pass the AbortController signal
        });
        // console.log(response);
        if (!response.ok) {
          if (response.status === 401) {
            toast.error("Unauthorized access. Please login again.");
            dispatch(setLogout());
            navigate("/login");
          }
          throw new Error("Cannot fetch data from the server");
        }

        const data = await response.json();
        // console.log(data);
        toast.info("data Loaded successfully...");
        toast.info("No. of Incidences: " + data.length);

        // return data;
        // console.log(data);
        setData(data);

      } catch (error) {
        if (error.name === "AbortError") {
          toast.error("Request timed out. Please try again.");
        } else {
          console.error("Error fetching data:", error);
          toast.error(error.message);
        }
      } finally {
        clearTimeout(timeoutId); // Clear the timeout
        setIsLoading(false);
      }
    }
    fetchData();
    /*
    // async function handleLLM(image) {
    //   // setLlmMessage(""); // Update the state with the LLM response
    //   const url = `http://localhost:${LLM_PORT}/api/generate`;

    //   const payload = {
    //     model: "gemma3:27b",
    //     stream: false,
    //     prompt:
    //     "Do you see any gray waste bins in the image? If yes, Do you see any garbage object (for example mattress, rubble bag, wooden broken furniture, sofa, refrigerator, bed base, microwave oven, TV, Dining table, auxiliary bed table, oven, garden furniture, bathroom fixtures (Toilets/bidets), boxes)? Please note that pure white rectangles are usually anonymous objects we hide in the image. Do not confuse orange-colored (orange box) or red-colored (red box) or waste bin with a garbage object — it is still a recycling container. Discard as garbage object any red and/or orange large/big object. Be aware that public chair (bench) for pedestrians perhaps highlighted in a red bounding box in the image are not garbage. An object similar to a orange refrigerator and/or red refrigerator is a olive waste or clothes bins and not a garbage object. These can have graffitis. Answer with only a json object with two variables called bintrash and garbage-objects in true or false corresponding to what you see.",
    //     // "Do you see any gray waste bins in the image? If yes, Do you see any garbage object (for example mattress, rubble bag, wooden broken furniture, sofa, refrigerator, bed base, microwave oven, TV, Dining table, auxiliary bed table, oven, garden furniture, bathroom fixtures (Toilets/bidets), boxes)? Please note that pure white rectangles are usually anonymous objects we hide in the image. Do not confuse orange-colored (orange box) or red-colored (red box) or waste bin with a garbage object — it is still a recycling container. Discard as garbage object any red and/or orange large/big object. An object similar to a orange refrigerator and/or red refrigerator is a olive waste or clothes bins and not a garbage object. These can have graffitis. Answer with only a json object with two variables called bintrash and garbage-objects in true or false corresponding to what you see.",
    //       // "Do you see large trash bins also called recycling containers in the image? If yes, do you see any big waste objects throwed next to them? Answer with only a json object with two variables called bintrash and garbage-objects in true or false corresponding to what you see, please note that white rectangles are usually anonymous objects we hide it.",
    //     // "what is in this image?! please focuse on trash pins and carbage and every thing near it. make the answer as report",
    //     // "prompt": "can you see any trash objects near to trash pins, if yes please tell me what are they",
    //     images: [image], // Use the base64 image from the clicked item
    //     // // "messages": [
    //     // //   {
    //     // //     "role": "user",
    //     // //   },
    //     // ],
    //   };
    //   // console.log(item.image_base64)
    //   try {
    //     const response = await fetch(url, {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         // Authorization: `Bearer ${token}`, // Add token if required
    //       },
    //       body: JSON.stringify(payload),
    //     });

    //     if (!response.ok) {
    //       throw new Error("Failed to fetch LLM response");
    //     }
    //     // console.log("LLM Response:", response);
    //     // const responseText = await response.text();
    //     // console.log("Raw Response:", responseText);
    //     const data = await response.json();
    //     // console.log("LLM Response:", JSON.parse(data.response.replace(/```(json)?\n?/, "").replace(/\n?```$/, "")));
    //     // console.log("LLM Response:", data.response);
    //     const llmConfirm = JSON.parse(
    //       data.response.replace(/\n?```$/, "").replace(/```(json)?\n?/, "")
    //     );
    //     console.log("LLM Response:", llmConfirm);
    //     return llmConfirm;
    //     // Extract the description from the response
    //     // const description = data.response || " ";
    //     // setLlmMessage(description); // Update the state with the LLM response
    //     // toast.success("LLM Response Received!");
    //   } catch (error) {
    //     console.error("Error interacting with LLM:", error);
    //     // setLlmMessage(" ");
    //     toast.error("Error interacting with LLM");
    //   }
    // }
    // async function fetchDataAndHandleLLM() {
    //   try {
    //     setIsLoading(true);
    //     const data = await fetchData();
    //     if (user.role === "admin") {
    //       toast.info("Starting LLM...");
    //       for (const item of data) {
    //         item.llm = await handleLLM(item.image_base64); // Assign the LLM response to the item
    //         if (
    //           item.llm.bintrash === true &&
    //           item.llm["garbage-objects"] === true
    //         ) {
    //           // console.log(item);
    //           // console.log(JSON.stringify(item));
    //           const formData = new FormData();
    //           const imageBlob = base64ToBlob(item.image_base64, 'image/jpeg');
    //           formData.append("filename", item.filename);
    //           formData.append("image", imageBlob, "image.png");
    //           formData.append("city", item.city);
    //           formData.append("Latitude", item.latitude);
    //           formData.append("Longitude", item.longitude);

    //           const response = await fetch(
    //             "https://api.up2smart.com:5001/final-images",
    //             {
    //               method: "POST",
    //               headers: {
    //                 Authorization: `Bearer ${token}`, // Add the Authorization header
    //               },
    //               body: formData,
    //             }
    //           );
    //           if (response.ok) {
    //             console.log("Image sent successfully:", item.filename);
    //           } else {
    //             console.error(
    //               "Failed to send image:",
    //               item.filename,
    //               response.statusText
    //             );
    //           }
    //         }
    //       }
    //     } else {
    //       data.forEach((item) => {
    //         item.llm = "No response from LLM";
    //       });
    //     }

    //     setData(data);
    //     toast.success("Map Loaded successfully..");
    //     toast.info(`${data.length} images`, {
    //       // position: 'top-center',
    //     });
    //   } catch (error) {
    //     console.error("Error in fetchDataAndHandleLLM:", error);
    //     toast.error("Error in Loading Map");
    //   } finally {
    //     setIsLoading(false);
    //   }
    // }
    // async function fetchDataManager(){
    //   try {
    //     setIsLoading(true);
    //     const data = await fetchData("/latest-final-images");
    //     setData(data);
    //     toast.success("Map Loaded successfully..");
    //     toast.info(`${data.length} images`, {
    //       // position: 'top-center',
    //     });
    //   } catch (error) {
    //     // console.error("Error in :", error);
    //     toast.error("Error in Loading Map");
    //   } finally {
    //     setIsLoading(false);
    //   }
    // }
    // if (user.role === "manager") {
    //   fetchDataManager();
    //   return;
    // }
    // fetchDataAndHandleLLM();
  */
  }, [token, dispatch, navigate]);

  // async function handleLLM(image) {
  //   // setLlmMessage(""); // Update the state with the LLM response
  //   const url = `http://localhost:${LLM_PORT}/api/generate`;

  //   const payload = {
  //     model: "gemma3:4b",
  //     stream: false,
  //     prompt:
  //       "Do you see large trash bins also called recycling containers in the image? If yes, do you see any big waste objects throwed next to them? Answer with only a json object with two variables called bintrash and garbage-objects in true or false corresponding to what you see, please note that white rectangles are usually anonymous objects we hide it.",
  //     // "what is in this image?! please focuse on trash pins and carbage and every thing near it. make the answer as report",
  //     // "prompt": "can you see any trash objects near to trash pins, if yes please tell me what are they",
  //     images: [image], // Use the base64 image from the clicked item
  //     // // "messages": [
  //     // //   {
  //     // //     "role": "user",
  //     // //   },
  //     // ],
  //   };
  //   // console.log(item.image_base64)
  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         // Authorization: `Bearer ${token}`, // Add token if required
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) {
  //       throw new Error("Failed to fetch LLM response");
  //     }
  //     // console.log("LLM Response:", response);
  //     // const responseText = await response.text();
  //     // console.log("Raw Response:", responseText);
  //     const data = await response.json();
  //     // console.log("LLM Response:", JSON.parse(data.response.replace(/```(json)?\n?/, "").replace(/\n?```$/, "")));
  //     // console.log("LLM Response:", data.response);
  //     const llmConfirm = JSON.parse(
  //       data.response.replace(/\n?```$/, "").replace(/```(json)?\n?/, "")
  //     );
  //     // console.log("LLM Response:", llmConfirm);
  //     return llmConfirm;
  //     // Extract the description from the response
  //     // const description = data.response || " ";
  //     // setLlmMessage(description); // Update the state with the LLM response
  //     // toast.success("LLM Response Received!");
  //   } catch (error) {
  //     console.error("Error interacting with LLM:", error);
  //     // setLlmMessage(" ");
  //     toast.error("Error interacting with LLM");
  //   }
  // }

  // async function handleLLM(item) {
  //   setLlmMessage(""); // Update the state with the LLM response
  //   const url = `http://localhost:${LLM_PORT}/api/generate`;

  //   const payload = {
  //     model: "gemma3:4b",
  //     stream: false,
  //     prompt: "Do you see large trash bins also called recycling containers in the image? If yes, do you see any big waste objects throwed next to them? Answer with a JSON response with two variables called bintrash and garbage-objects in true or false corresponding to what you see, please note that white rectangles are usually anonymous objects we hide it.",
  //       // "what is in this image?! please focuse on trash pins and carbage and every thing near it. make the answer as report",
  //     // "prompt": "can you see any trash objects near to trash pins, if yes please tell me what are they",
  //     images: [item.image_base64], // Use the base64 image from the clicked item
  //     // // "messages": [
  //     // //   {
  //     // //     "role": "user",
  //     // //   },
  //     // ],
  //   };
  //   // console.log(item.image_base64)
  //   try {
  //     const response = await fetch(url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         // Authorization: `Bearer ${token}`, // Add token if required
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) {
  //       throw new Error("Failed to fetch LLM response");
  //     }
  //     // console.log("LLM Response:", response);
  //     // const responseText = await response.text();
  //     // console.log("Raw Response:", responseText);
  //     const data = await response.json();
  //     // console.log("LLM Response:", JSON.parse(data.response.replace(/```(json)?\n?/, "").replace(/\n?```$/, "")));
  //     const llmConfirm = JSON.parse(data.response.replace(/```(json)?\n?/, "").replace(/\n?```$/, ""))

  //     // Extract the description from the response
  //     const description = data.response || " ";
  //     setLlmMessage(description); // Update the state with the LLM response
  //     // toast.success("LLM Response Received!");
  //   } catch (error) {
  //     console.error("Error interacting with LLM:", error);
  //     setLlmMessage(" ");
  //     toast.error("Error interacting with LLM");
  //   }
  // }
  return (
    <>
      <Header />
      <div className={style.mapContainer}>
        {isLoading ? (
          <LoadingOverlay isVisible={isLoading} message="Loading Map...">
            <MoonLoader color="#00BFFF" size={50} />
          </LoadingOverlay>
        ) : (
          <MapContainer
            center={mapPosition}
            zoom={14}
            scrollWheelZoom={true}
            className={style.map}
          >
            {/* Update the map center when mapPosition changes */}
            <UpdateMapCenter center={mapPosition} />
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            // url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
            />
            {data.map((item, index) => {
              const pos = [item.latitude, item.longitude];
              let customIcon = "";
              if (item.incidence === 1) {

                customIcon = L.icon({
                  // iconUrl: `${process.env.PUBLIC_URL}/images/popup-icon.png`, // your custom icon
                  iconUrl: red_popup, // your custom icon
                  iconSize: [24, 24],
                  // iconAnchor: [16, 32], // position the icon correctly
                  // popupAnchor: [0, -32],
                  // shadowUrl: iconShadow,
                  // shadowSize: [41, 41],
                });
              }
              else {
                customIcon = L.icon({
                  // iconUrl: `${process.env.PUBLIC_URL}/images/popup-icon.png`, // your custom icon
                  iconUrl: yellow_popup, // your custom icon
                  iconSize: [24, 24],
                  // iconAnchor: [16, 32], // position the icon correctly
                  // popupAnchor: [0, -32],
                  // shadowUrl: iconShadow,
                  // shadowSize: [41, 41],
                });
              }
              return (
                <Marker
                  position={pos}
                  icon={customIcon}
                  key={item.results_id}
                // eventHandlers={{
                //   click: () => handleLLM(item),
                // }}
                >
                  <Popup>
                    <div className={style.popup}>
                      <img
                        src={`data:image/png;base64,${item.image_base64}`}
                        alt="results from API"
                      />
                      <div className={style.incidence_info}>
                      <div>Results ID: #{item.results_id}</div>

                      <div>{new Date(item.collection_timestamp).toLocaleString('en-US', {
                        weekday: 'short',           // "Wed" 
                        day: '2-digit',            // "05"
                        month: 'short',            // "Nov"
                        year: 'numeric',           // "2025"
                        hour: '2-digit',           // "17"
                        minute: '2-digit',         // "33"
                        second: '2-digit',         // "49"
                        hour12: false,             // 24-hour format
                        // timeZone: 'Europe/Madrid', // CET timezone
                        // timeZoneName: 'long'      // "CET"
                      })} </div>
                      </div>
                      {role === 'manager' && 
                      <div className={style.incidence_form}>
                        <input onChange={(e)=>setIncidenceDescription(e.target.value)} type='text' placeholder='description'/>
                        <button disabled={sendIncident} onClick={()=>{removeIncidence(item.results_id)}}>Remove</button>
                      </div>}
                    </div>
                  </Popup>
                </Marker>
              );
            })}
          </MapContainer>
        )}
      </div>
    </>
  );
}

export default MapResults;
